export default __webpack_public_path__ + "static/media/leaderboard-no-arrow.92893fd0.svg";